import React from 'react';
import { DERSLER } from '../../lib/dersler.js';
import { MUFREDATLAR, URUNLER } from './sabitler';
import { secimSinifi, SECILI_ISARET, gunStr } from './yardimcilar';
import ZorlukDagilimPaneli from './ZorlukDagilimPaneli';
import DenemeManifestPaneli from './DenemeManifestPaneli';

// ============================================================
// A/B — TYT / AYT SAYISAL DENEMESİ içerik bölümü (Faz C, 2026-09-03).
// Format sabit (120/80); tek geçerli kısıt müfredat + önceki denemeleri hariç
// tutma + "bu yayınevine verilenler de dahil". Zorluk: ders bazlı profil + konu
// bazlı isteğe bağlı seviye (ZorlukDagilimPaneli). Liste: DenemeManifestPaneli.
// Sade akış (2026-09-03, kullanıcı): müfredat ve iki havuz seçeneği belirgin
// seçim butonu (`secimSinifi`, aria-pressed); özet metni yok.
// 2026-09-15 (yayınevi DB listesi): havuz seçeneği `ayniYayineviDahil` — Çıktı
// bölümünde yayınevi seçili DEĞİLSE pasif; başka yayınevine satılmış soru hiçbir
// zaman havuza girmez (eski "Yayınevine verilenler dahil" bayrağı kalktı).
// ============================================================
export default function DenemePaneli({
  urun, apiUrl, mufredat, setMufredat, denemeFizibilite,
  oncekiDenemeHaric, setOncekiDenemeHaric, ayniYayineviDahil, setAyniYayineviDahil, yayineviAd = '',
  denemeTarih = { min: '', max: '' }, setDenemeTarih = () => {},
  denemeOlustur, manifestYukleniyor, denemeManifest, manifestNot, aktifSlot,
  dersZorluk, setDersZorluk, konuZorluk, setKonuZorluk,
  slotCikar, slotOtoDoldur, slotAta, setAktifSlot, tumBosSlotlariDoldur,
}) {
  const bilgi = URUNLER[urun] || URUNLER.tyt;
  // Slot etiketi (slot-ders 2026-09-03): fizibilite yanıtındaki `ad` (Tarih-1 /
  // Coğrafya-2), yoksa DERSLER etiketi (TYT/AYT'de slot = ders).
  const slotEtiket = (ders) => {
    const d = ((denemeFizibilite && denemeFizibilite.testler) || []).flatMap(t => t.dersler).find(x => x.ders === ders);
    return (d && d.ad) || DERSLER.find(x => x.value === ders)?.label || ders;
  };
  return (
    <div className="mt-2 space-y-3">
      <div className="text-[11px] text-indigo-800 bg-indigo-50 border border-indigo-100 rounded-lg px-3 py-2">
        <strong>{bilgi.ad}</strong> — {bilgi.toplam} soru, ÖSYM test sırası ve kotalarıyla:{' '}
        {bilgi.dokum}
        {' '}— kapak + açıklama + arka kapak + test bölümlü cevap anahtarı dahil. Adet/ders/konu filtresi yoktur.
        {bilgi.sinav === 'AYT_SOZEL' && ' Sözel havuzu yalnız Maarif müfredatındadır; "2018" seçilirse slotlar boş kalır.'}
      </div>

      {/* MÜFREDAT — tam denemede tek geçerli kısıt (2026-08-19, öğretmen isteği).
          ÖLÇÜM (canlı fizibilite ucu): TYT+2018'de sosyal dersler, AYT+Maarif'te
          fen dersleri yok. Seçim engellenmez; rozet ve uyarı nedenini söyler. */}
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-[10px] text-gray-500 font-bold uppercase">Müfredat</span>
        {MUFREDATLAR.map(m => {
          const aktif = (mufredat || '') === m.v;
          return (
            <button key={m.v || 'hepsi'} type="button" aria-pressed={aktif}
              onClick={() => setMufredat(m.v)}
              title={m.v === 'MEB_2018'
                ? 'MEB 2018 müfredatı (2026 ve 2027 YKS)'
                : m.v === 'Maarif_2024'
                  ? 'Maarif 2024 müfredatı (2028 ve sonrası YKS; AYT fen dersleri bu havuzda yok)'
                  : 'Karma: iki müfredatın soruları aynı kitapçığa girer — yalnız bilerek seçin'}
              className={secimSinifi(aktif)}>
              {/* Tam denemede "Hepsi" = karma kitapçık; adı bunu açıkça söyler (2026-09-30). */}
              {aktif ? SECILI_ISARET : ''}{m.v === '' ? 'Karma' : m.l}
            </button>
          );
        })}
        {denemeFizibilite && (
          <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${
            denemeFizibilite.uygun ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}
            title={denemeFizibilite.uygun
              ? 'Havuz yeterli — her ders kendi kotasını karşılıyor'
              : 'Havuz yetersiz — aşağıdaki tabloda kırmızı dersler eksik'}>
            {denemeFizibilite.uygun ? 'havuz uygun' : 'havuz yetersiz'}
          </span>
        )}
        <span className="text-[10px] text-gray-500 font-bold uppercase ml-2">Havuz</span>
        <button type="button" aria-pressed={!!oncekiDenemeHaric}
          onClick={() => setOncekiDenemeHaric(!oncekiDenemeHaric)}
          title="Daha önce basılmış denemelerde kullanılan sorular havuzdan düşülür"
          className={secimSinifi(!!oncekiDenemeHaric)}>
          {oncekiDenemeHaric ? SECILI_ISARET : ''}Önceki denemeler hariç
        </button>
        <button type="button" aria-pressed={!!ayniYayineviDahil} data-ayni-yayinevi-dahil
          onClick={() => setAyniYayineviDahil(!ayniYayineviDahil)}
          disabled={!yayineviAd}
          title={yayineviAd
            ? `${yayineviAd} yayınevine daha önce verilmiş sorular da havuza girer; başka yayınevine satılmış sorular hiçbir zaman girmez`
            : 'Önce Çıktı bölümünde “Soruları sistemden düşür” açıp alıcı seçin'}
          className={`${secimSinifi(!!ayniYayineviDahil)} disabled:opacity-40 disabled:cursor-not-allowed`}>
          {ayniYayineviDahil ? SECILI_ISARET : ''}Bu yayınevine verilenler de dahil
        </button>
        {/* ÜRETİM TARİHİ ARALIĞI (2026-09-21, öğretmen: "tam denemeye de ekle").
            Havuzu daraltır; fizibilite rozeti bu daraltılmış havuza göre yanar. */}
        <span className="text-[10px] text-gray-500 font-bold uppercase ml-2"
          title="Sorunun üretildiği gün — havuzu bu aralıkla sınırlar (boş = tüm havuz)">Tarih</span>
        <input type="date" data-deneme-tarih="min" value={denemeTarih.min || ''} max={denemeTarih.max || undefined}
          onChange={e => setDenemeTarih({ ...denemeTarih, min: e.target.value })}
          title="Bu tarihten itibaren üretilenler"
          className="px-1.5 py-1 rounded border border-gray-300 text-[11px]" />
        <span className="text-[10px] text-gray-400">→</span>
        <input type="date" data-deneme-tarih="max" value={denemeTarih.max || ''} min={denemeTarih.min || undefined}
          onChange={e => setDenemeTarih({ ...denemeTarih, max: e.target.value })}
          title="Bu tarihe kadar (gün dâhil)"
          className="px-1.5 py-1 rounded border border-gray-300 text-[11px]" />
        {[{ l: 'Bugün', n: 0 }, { l: '7 gün', n: 6 }, { l: '30 gün', n: 29 }].map(h => (
          <button key={h.l} type="button" onClick={() => setDenemeTarih({ min: gunStr(h.n), max: gunStr(0) })}
            className="text-[10px] px-2 py-0.5 rounded font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200">
            {h.l}
          </button>
        ))}
        {(denemeTarih.min || denemeTarih.max) && (
          <button type="button" onClick={() => setDenemeTarih({ min: '', max: '' })}
            className="text-[10px] px-2 py-0.5 rounded font-semibold bg-gray-100 text-gray-500 hover:bg-gray-200">
            ✕ tarih
          </button>
        )}
        <div className="flex-1" />
        {/* DENEME OLUŞTUR — ön-kontrol ucu üzerinden soru listesini üretir
            (LaTeX derlemez, hızlıdır). Liste geldikten sonra önizleme/PDF SEÇİM
            YAPMAZ; öğretmenin onayladığı liste basılır. */}
        <button onClick={denemeOlustur}
          disabled={manifestYukleniyor || (denemeFizibilite && denemeFizibilite.uygun === false)}
          title="Soru listesini üret — sonra tek tek ekleyip çıkarabilirsiniz"
          className="px-3 py-1.5 rounded-lg text-xs font-bold bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-40">
          {manifestYukleniyor ? '⏳ Hazırlanıyor...' : (denemeManifest ? '🔄 Listeyi Yenile' : '🧩 Deneme Oluştur')}
        </button>
      </div>
      {denemeFizibilite && denemeFizibilite.uygun === false && (
        <div className="text-[10px] text-red-700">
          ⚠ Bu müfredatta havuz yetersiz:{' '}
          {(denemeFizibilite.eksik_dersler || [])
            .map(e => `${slotEtiket(e.ders)} (${e.havuz}/${e.kota})`)
            .join(', ')}
          {(denemeFizibilite.konu_hatalari || []).length > 0 && ` · ${denemeFizibilite.konu_hatalari.join('; ')}`}
          . Müfredatı değiştirin veya bekleyen soruları onaylayın.
        </div>
      )}

      {/* FİZİBİLİTE + ZORLUK (ders bazlı profil + konu bazlı seviye) */}
      {denemeFizibilite && (
        <div className={`rounded-lg border p-2.5 text-[11px] ${
          denemeFizibilite.uygun ? 'bg-emerald-50 border-emerald-200 text-emerald-900'
            : 'bg-red-50 border-red-300 text-red-800'}`}>
          <div className="font-bold mb-1.5">
            {denemeFizibilite.uygun ? '✓' : '⛔'} {bilgi.ad} fizibilitesi
            — hedef {denemeFizibilite.toplam_hedef} soru
            {denemeFizibilite.uygun ? ' (üretilebilir)' : ' (havuz yetersiz)'}
            {oncekiDenemeHaric && <span className="font-normal"> · önceki denemeler hariç</span>}
          </div>
          <ZorlukDagilimPaneli fizibilite={denemeFizibilite} dersZorluk={dersZorluk} onDegis={setDersZorluk}
            konuZorluk={konuZorluk} onKonuZorlukDegis={setKonuZorluk} apiUrl={apiUrl} mufredat={mufredat} />
          {(denemeFizibilite.uyarilar || []).length > 0 && (
            <details className="mt-1.5">
              <summary className="cursor-pointer opacity-80">Uyarılar ({denemeFizibilite.uyarilar.length})</summary>
              <ul className="mt-1 ml-4 list-disc space-y-0.5 opacity-90">
                {denemeFizibilite.uyarilar.map((u, i) => <li key={i}>{u}</li>)}
              </ul>
            </details>
          )}
        </div>
      )}
      {!denemeFizibilite && (
        <div className="text-[11px] text-gray-500">⏳ Havuz fizibilitesi yükleniyor…</div>
      )}

      {/* DENEME LİSTESİ — ekleme/çıkarma */}
      <DenemeManifestPaneli
        manifest={denemeManifest} not={manifestNot} yukleniyor={manifestYukleniyor}
        aktifSlot={aktifSlot} apiUrl={apiUrl}
        mufredat={mufredat}
        onCikar={slotCikar} onOtoDoldur={slotOtoDoldur} onAta={slotAta}
        onSlotIptal={() => setAktifSlot(null)} onSlotSec={(ders, idx) => setAktifSlot({ ders, idx })}
        onTumBoslariDoldur={tumBosSlotlariDoldur} onOlustur={denemeOlustur} />
    </div>
  );
}
